
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinpabal() {



const cardData = {
  keyword: 'Cab Service in Pabal MIDC Pune',
  heading: 'eTravo: Comprehensive Corporate Cab Services in Pabal MIDC Pune',
  headingDescription: 'eTravo delivers dependable and professionally managed corporate cab services in Pabal MIDC Pune, tailored for industrial workers, management staff, and business visitors. Our services ensure seamless employee transportation, executive mobility, and client transfers with a fleet of clean, GPS-enabled, air-conditioned vehicles. Whether you need shift-based cabs, monthly rentals, or on-demand rides, eTravo is equipped to meet diverse requirements with punctuality, safety, and efficiency. We help companies reduce travel stress, boost productivity, and maintain operational flow through smart, flexible cab solutions in and around Pabal MIDC.',

  top: 'Key Locations in Pabal MIDC Pune Covered by eTravo’s Corporate Cab Services',
  topPlaces: [
    {
      title: 'Pabal MIDC Industrial Zone',
      description: 'This industrial zone hosts manufacturing and engineering units that require structured employee transport. eTravo supports this need by offering organized, time-sensitive cab services tailored for industrial shifts.'
    },
    {
      title: 'Corporate Office Complexes in Pabal MIDC',
      description: 'Offices within the MIDC zone need dependable and professional transport for staff and visiting clients. eTravo ensures a smooth travel experience with professional drivers and premium vehicle options.'
    },
    {
      title: 'Logistics and Warehousing Units',
      description: 'Cab services designed to support transportation of supervisors, warehouse staff, and logistics coordinators. We offer flexible pickup/drop schedules aligned with operational shifts to enhance efficiency.'
    },
    {
      title: 'Nearby Workforce Residential Areas',
      description: 'Our services connect residential zones with industrial hubs, ensuring workers arrive on time and return safely, helping companies retain talent through dependable transport solutions.'
    },
    {
      title: 'Skill Training & Development Centers',
      description: 'eTravo provides cab solutions for trainees and instructors traveling to learning centers in the area, helping businesses train new employees without logistical stress.'
    },
    {
      title: 'Client and Vendor Meeting Points',
      description: 'We offer professional cab services for client visits, business negotiations, and partner tours, helping businesses make strong impressions and avoid delays.'
    }
  ],

  services: [
    {
      name: 'Pabal MIDC Corporate Cab Rentals',
      description: 'Our corporate cab rentals offer businesses customized long-term or short-term vehicle options. Whether for daily use or special projects, we provide sanitized, GPS-enabled cabs with professional drivers to keep operations running smoothly and safely.'
    },
    {
      name: 'Employee Transport Cab Pabal MIDC',
      description: 'eTravo offers scheduled cab services to ensure employees are picked up and dropped off on time, especially for factories and units with multiple shifts. These services reduce absenteeism and improve overall productivity across operations.'
    },
    {
      name: 'Business Cab Services Pabal MIDC',
      description: 'Our business cab services cater to senior managers, field staff, and guest visitors. We ensure smooth, prompt transportation using well-maintained vehicles suitable for both urban and industrial routes, enhancing your brand’s professionalism.'
    },
    {
      name: 'Corporate Staff Cabs Pabal MIDC',
      description: 'These cabs are structured to accommodate staff working in production, admin, or field roles. With dedicated drivers, real-time tracking, and shift-based planning, we help streamline corporate mobility in Pabal MIDC.'
    },
    {
      name: 'Reliable Corporate Cab Service Pabal MIDC',
      description: 'eTravo is trusted for its punctual, safe, and professionally managed cab services in industrial areas like Pabal MIDC. We maintain a fleet of reliable vehicles and trained drivers to ensure consistent transport performance for every ride.'
    },
    {
      name: 'AC Corporate Cabs Pabal MIDC',
      description: 'Our air-conditioned corporate cabs provide a comfortable and hygienic travel experience, particularly appreciated in long commutes or summer months. Vehicles are cleaned regularly and come equipped with basic travel amenities.'
    },
    {
      name: 'Staff Pickup and Drop Cab Pabal MIDC',
      description: 'We schedule staff pick-up and drop-off services based on shift times, ensuring no disruptions in attendance or workflow. Vehicles are dispatched according to operational rosters, offering reliability even in remote or late-night shifts.'
    },
    {
      name: 'Affordable Business Cab Rentals Pabal MIDC',
      description: 'Cost-effective cab rental plans that include monthly contracts routes, and flexible billing. Perfect for companies looking to reduce transportation costs without compromising on service quality or reliability.'
    },
    {
      name: 'Executive Cab Services Pabal MIDC',
      description: 'Premium executive cab services designed for senior managers, board members, and important guests. We provide high-end vehicles, uniformed drivers, and assured punctuality for a seamless, executive-grade travel experience.'
    },
    {
      name: 'Monthly Corporate Cab Rentals Pabal MIDC',
      description: 'Fixed monthly rental services tailored for businesses that require consistent, daily transport for employees. Our packages include route mapping, real-time monitoring, and backup vehicles to ensure zero downtime.'
    },
    {
      name: 'Industrial Area Employee Transport Pabal MIDC',
      description: 'eTravo specializes in industrial employee transport with route optimization, shift alignment, and driver coordination. This end-to-end solution is ideal for manufacturers and large production units in Pabal MIDC.'
    },
    {
      name: 'Corporate Client Cabs Pabal MIDC',
      description: 'Dedicated cab services for client visits, factory tours, and business meetings, ensuring your guests experience professionalism from arrival to departure. We prioritize punctuality and a smooth travel experience.'
    },
    {
      name: 'Business Meeting Cabs Pabal MIDC',
      description: 'Whether it’s a scheduled site visit or an urgent business meeting, eTravo provides fast, responsive cab services for corporate teams. Our trained drivers understand business urgency and deliver prompt, route-optimized transport.'
    },
    {
      name: 'Pabal Industrial Area Cab Hire',
      description: 'On-demand or scheduled cab hire services for businesses operating in Pabal MIDC. Use our services for inter-office commutes, industrial visits, and short-term project-based mobility solutions with reliable support.'
    },
    {
      name: 'Corporate Shuttle Cabs Pabal MIDC',
      description: 'Group transport solutions using minibuses and shuttles to move employees across factory units, residential zones, and transit hubs. Ideal for large-scale businesses seeking organized and cost-effective transportation.'
    }
  ],

  tableData: [
    ['Pabal MIDC Corporate Cab Rentals', 'Employee Transport Cab Pabal MIDC'],
    ['Business Cab Services Pabal MIDC', 'Corporate Staff Cabs Pabal MIDC'],
    ['Reliable Corporate Cab Service Pabal MIDC', 'AC Corporate Cabs Pabal MIDC'],
    ['Staff Pickup and Drop Cab Pabal MIDC', 'Affordable Business Cab Rentals Pabal MIDC'],
    ['Executive Cab Services Pabal MIDC', 'Monthly Corporate Cab Rentals Pabal MIDC'],
    ['Industrial Area Employee Transport Pabal MIDC', 'Corporate Client Cabs Pabal MIDC'],
    ['Business Meeting Cabs Pabal MIDC', 'Pabal Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Pabal MIDC', '']
  ],


"whychoose": [
  {
    "WhyChooseheading": "Specialized Corporate Cab Services for Pabal MIDC Pune",
    "WhyChoosedescription": "eTravo offers expertly tailored corporate cab services to meet the unique transportation demands of businesses in Pabal Industrial Area MIDC, Pune. Recognizing the logistical challenges in this developing industrial region, we ensure timely, efficient, and comfortable rides that boost employee productivity and reduce commute-related stress. Our comprehensive solutions are designed to seamlessly support daily operations and enhance workforce satisfaction."
  },
  {
    "WhyChooseheading": "Extensive Fleet Offering for Diverse Corporate Needs",
    "WhyChoosedescription": "Our wide-ranging fleet includes sedans, SUVs, and MUVs to accommodate varying corporate travel requirements—whether for employee commutes, client visits, or inter-office transfers. Each vehicle is maintained to the highest standards of safety and comfort, ensuring a premium travel experience."
  },
  {
    "WhyChooseheading": "Experienced Drivers Well-Acquainted with Pabal MIDC Routes",
    "WhyChoosedescription": "Our professional drivers possess thorough knowledge of the roads and traffic patterns within Pabal MIDC and surrounding areas. Their expertise ensures prompt pickups, efficient routing, and smooth journeys, minimizing delays and maximizing reliability for your business transportation needs."
  },
  {
    "WhyChooseheading": "Flexible Booking and Scheduling Tailored for Corporate Efficiency",
    "WhyChoosedescription": "We offer customizable booking options including on-demand rides, scheduled pickups, and long-term contracts. This flexibility empowers businesses to manage transportation services that align perfectly with fluctuating employee shifts and project timelines."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking for Enhanced Safety and Transparency",
    "WhyChoosedescription": "All vehicles are equipped with advanced GPS tracking, enabling corporate clients to monitor employee rides in real-time. This feature ensures passenger safety, operational transparency, and swift response to any travel disruptions."
  },
  {
    "WhyChooseheading": "Clear and Transparent Billing with Detailed Invoices",
    "WhyChoosedescription": "Our transparent billing process provides detailed invoices inclusive of trip logs and fare breakdowns, facilitating effortless expense tracking and simplified reimbursement procedures for corporate finance departments."
  },
  {
    "WhyChooseheading": "Strict Safety and Hygiene Measures for Passenger Wellbeing",
    "WhyChoosedescription": "Committed to health and safety, we maintain rigorous hygiene protocols such as regular vehicle sanitization, driver health screenings, and adherence to mask mandates, creating a secure and comfortable travel environment."
  },
  {
    "WhyChooseheading": "Dedicated Account Management for Personalized Corporate Support",
    "WhyChoosedescription": "Each corporate client is assigned a dedicated account manager who offers personalized assistance with bookings, resolves queries swiftly, and customizes transportation solutions to best meet the company’s unique requirements."
  }
]
}

const faqData = [
  [
    {
      question: "Which areas are covered by your cab service in Pabal MIDC Pune?",
      answer: "Our corporate cab service extends throughout Pabal Industrial Area MIDC and nearby industrial zones, ensuring comprehensive coverage for your business needs."
    },
    {
      question: "Can we schedule recurring rides for employees?",
      answer: "Yes, we provide flexible scheduling options to set up recurring rides, ensuring consistent and timely employee transportation."
    },
    {
      question: "Do you offer monthly billing for corporate clients?",
      answer: "Yes, we offer monthly billing cycles with detailed invoices to simplify financial management and expense tracking."
    },
    {
      question: "Are your drivers trained in professional and corporate etiquette?",
      answer: "Absolutely. All our drivers undergo thorough training to maintain high standards of professionalism, courtesy, and safety."
    },
    {
      question: "How do you ensure passenger safety during trips?",
      answer: "We utilize real-time GPS tracking, conduct regular vehicle maintenance, and enforce strict hygiene protocols, including sanitization and mask usage."
    },
    {
      question: "Is there dedicated corporate client support available?",
      answer: "Yes, we assign dedicated account managers to provide personalized support and prompt assistance to our corporate clients."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Prakash More",
    designation: "Operations Manager, Pabal Industries",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s cab services in Pabal MIDC have greatly enhanced our employee commute experience, ensuring timely pickups and a high level of professionalism.”"
  },
  {
    name: "Ms. Snehal Patil",
    designation: "HR Head, Green Leaf Technologies",
    rating: [1, 1, 1, 1, 1],
    text: "“The transparent billing and dedicated support from eTravo make them our preferred corporate transportation partner in Pabal MIDC.”"
  }
];


























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Pabal MIDC Pune",
  "image": "https://www.etravo.in/images/keyword/cab-service-pabal-midc.jpg",
  "description": "Reliable corporate cab service in Pabal MIDC Pune for employee transport, business meetings, and industrial area commutes. Affordable AC corporate cabs with trusted drivers by eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7890"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-pabal-midc-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Cab Service in Pabal MIDC Pune | Corporate & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire cab service in Pabal MIDC Pune for corporate staff transport, business meetings, and industrial area commutes. Affordable and reliable AC corporate cabs by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/62.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinpabal;